import React, { createContext, FC } from "react";
import { useCurrentUserData } from "../hooks/user-data/user-data";
import { useSettings } from "../hooks";
import { Permission, usePermissionCheck } from "../hooks";
import { CurrentUserDataResult } from "~/gql/graphql";
type GlobalContext = {
  pmsName: string;
  currentUser: CurrentUserDataResult | null;
  showGpm?: boolean;
  enableAi?: boolean;
  enableTechPricing?: boolean;
  decimalTimeInput: boolean;
};

export const GlobalContext = createContext<GlobalContext>({
  pmsName: "",
  currentUser: null,
  showGpm: true,
  enableAi: false,
  enableTechPricing: false,
  decimalTimeInput: false,
});

export const GlobalContextProvider: FC = ({ children }) => {
  const { settings } = useSettings();
  const { currentUser } = useCurrentUserData({ cache: false });
  const gpmOverride = usePermissionCheck(Permission.GPM_OVERRIDE);
  const showGpm =
    (!settings?.restrictGpmVisibility || currentUser?.restrictedGpmVisible || gpmOverride) ?? false;
  const enableAi = settings?.enableAi ?? false;
  const enableTechPricing = settings?.enableTechPricing ?? false;
  const decimalTimeInput = settings?.decimalTimeInput ?? false;
  return (
    <>
      <GlobalContext.Provider
        value={{
          pmsName: settings?.organisationPmsName || "PMS",
          currentUser,
          showGpm,
          enableAi,
          enableTechPricing,
          decimalTimeInput,
        }}
      >
        {children}
      </GlobalContext.Provider>
    </>
  );
};
